import type { ReactNode } from "react";
import { motion } from "framer-motion";
import { ChatBlockingBottomSheetHost } from "@sudowrite/shared-chat";
import { SPRING_BOUNCY, FADE_FAST } from "./Plan/animations";

export function BlockingBottomSheetOverlay({
  overlayKey,
  titleId,
  children,
  withDropShadow = false,
}: {
  overlayKey: string;
  titleId: string;
  children: ReactNode;
  withDropShadow?: boolean;
}) {
  return (
    <ChatBlockingBottomSheetHost
      titleId={titleId}
      testId={overlayKey}
      renderAnimatedShell={(framed) => (
        <motion.div
          key={overlayKey}
          initial={{ clipPath: "inset(100% 0 0 0 round 12px)" }}
          animate={{ clipPath: "inset(0% 0 0 0 round 12px)" }}
          exit={{ clipPath: "inset(100% 0 0 0 round 12px)", opacity: 0 }}
          transition={{ clipPath: SPRING_BOUNCY, opacity: FADE_FAST }}
          className="min-h-0 w-full max-h-full overflow-hidden rounded-xl border border-solid border-app-grey-3 bg-app-menu-color"
          style={withDropShadow ? { filter: "var(--card-drop-shadow-filter)" } : undefined}
        >
          {framed}
        </motion.div>
      )}
    >
      {children}
    </ChatBlockingBottomSheetHost>
  );
}
